<template>
  <f7-popup id="PopupMediaPermissions" class="popup-media-permissions">
    <f7-view>
      <f7-page>
        <f7-block>
          <div class="popup-media-permissions-title">
            Microphone and Camera Check
          </div>
          <div class="popup-media-permissions-subtitle">
            Press OK in browser access questions to enable audio / video chat
          </div>

          <div class="popup-media-permissions-icons">
            <div>
              <img src="static/audio.svg" alt="icon" />
              <f7-icon
                :f7="
                  permissions.microphone === 'granted'
                    ? 'checkmark_alt_circle_fill'
                    : 'multiply_circle_fill'
                "
                :color="permissions.microphone === 'granted' ? 'green' : 'red'"
              ></f7-icon>
            </div>
            <div>
              <img src="static/video.svg" alt="icon" />
              <f7-icon
                :f7="
                  permissions.camera === 'granted'
                    ? 'checkmark_alt_circle_fill'
                    : 'multiply_circle_fill'
                "
                :color="permissions.camera === 'granted' ? 'green' : 'red'"
              ></f7-icon>
            </div>
          </div>
        </f7-block>

        <f7-block
          v-if="
            permissions.camera !== 'granted' ||
              permissions.microphone !== 'granted'
          "
          class="popup-media-permissions-action"
        >
          <f7-button
            class="custome-round gradient"
            fill
            large
            round
            @click="getPermissions"
          >
            Permission request
          </f7-button>
        </f7-block>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PopupMediaPermissions',

  computed: {
    ...mapState({
      permissions: (state) => state.permissions
    })
  },

  methods: {
    getPermissions() {
      // const { microphone, camera } = this.permissions;

      navigator.getUserMedia(
        { audio: true },
        () => {
          localStorage.setItem('microphone', true);
          this.$store.commit('SET_USER_PERMISSIONS', {
            type: 'microphone',
            result: 'granted'
          });
        },
        () => {}
      );

      navigator.getUserMedia(
        { video: true },
        () => {
          localStorage.setItem('camera', true);
          this.$store.commit('SET_USER_PERMISSIONS', {
            type: 'camera',
            result: 'granted'
          });
        },
        () => {}
      );
    }
  }
};
</script>

<style lang="less">
.popup-media-permissions:not(.popup-tablet-fullscreen) {
  // width: var(--f7-popup-tablet-width);
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 500px;
    --f7-popup-tablet-height: 450px;
  }
}

.popup-media-permissions-title {
  text-align: center;
  font-size: 28px;
  font-weight: 400;
}

.popup-media-permissions-subtitle {
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
}

.popup-media-permissions-icons {
  margin-top: 50px;
  display: flex;
  align-items: center;

  div {
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  img {
    width: 110px;
  }

  .icon {
    margin-top: 25px;
  }
}

.popup-media-permissions-action {
  a {
    max-width: 225px;
    margin: 0 auto;
  }
}
</style>
